
//App version
export const appVersion = '2.0.0'

//App environments
export const environments = {
  LOCAL: 'local',
  DEV: 'dev',
  QA: 'qa',
  STAGING: 'staging',
  PRODUCTION: 'production',
}

//App URL's
export const appUrls = {
  LOCAL: 'http://localhost:8887',
  DEV: 'https://messenger.dev.arist.app',
  QA: 'https://messenger.qa.arist.app',
  STAGING: 'https://messenger.staging.arist.app',
  PRODUCTION: 'https://messenger.arist.app',
}

//API URL's
export const apiBaseUrls = {
  TEST: 'http://localhost:8888',
  LOCAL: 'http://localhost:8888',
  DEV: 'https://dev.arist.app',
  QA: 'https://qa.arist.app',
  STAGING: 'https://staging.arist.app',
  PRODUCTION: 'https://arist.app',
}

//Image URL's
export const imageUrls = {
  DEV: 'https://arist-dev-user-images.s3.us-east-2.amazonaws.com',
  QA: 'https://arist-qa-user-images.s3.us-east-2.amazonaws.com',
  STAGING: 'https://arist-staging-user-images.s3.us-east-2.amazonaws.com',
  PRODUCTION: 'https://arist-production-user-images.s3.us-east-2.amazonaws.com',
}

//App themes
export const themes = {
  LIGHT: 'light',
  DARK: 'dark',
}
